/*--------------------------------------
              Update Cart
 --------------------------------------*/
UpdateCart = {
  init: function () {
    $("body.cart .btn-quick-addtocart").click(function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      setTimeout(location.reload.bind(location), 1000);
    });
  }
};


$(document).ready(function () {
  UpdateCart.init();
});